<template>
    <div class="content content-full">
        <ul class="lista-cat">
            <li class="cat-consigli text-uppercase" v-if="this.advices.length">
                <router-link :to="{name:'menu.category.advices', query:{ids:this.advices}}" class="d-flex align-items-center f18">
                  <span class="material-symbols-outlined mr-3 f40">heart_smile</span>{{$t('consigliperte')}}
                </router-link>
            </li>
            <li v-for="category in this.categories">
                <router-link :to="{name:'menu.category.products', params:{id:category.id}}" class="d-flex justify-content-between align-items-center">
                   <div>
                      {{category.alias}}
                      <div v-if="category.descrizione" class="f13 lh15">
                        {{category.descrizione.ellipsis(70)}}
                      </div>
                   </div>
                  <span class="material-symbols-outlined color">arrow_right_alt</span>
                </router-link>
            </li>
        </ul>
        <div class="gray text-center padding" v-if="this.general_notes">
            {{$t('note_generali_label')}}: <span v-html="this.general_notes"></span>
        </div>
    </div>
</template>

<script>
import {mapState, mapActions} from 'vuex';
import {getCategoriesList} from '../../api/restaurant';

export default {
    name: "Categories",
    data() {
        return {
            general_notes: '',
            advices: [],
            categories: []
        }
    },
    created() {
        this.fetch();
    },
    computed: {
        ...mapState('restaurant', {
            id_ristorante: state => state.id,
            locale: state => state.locale
        }),
        ...mapState('localization', {
            language: state => state.language
        }),
        ...mapState('order', {
            order: state => state
        }),
        ...mapState('auth', {
            user: state => state
        })
    },
    watch: {
        language: function () {
            this.fetch();
        }
    },
    methods: {
        fetch: function () {
            this.showLoading(true);
            getCategoriesList(this.language, {
                id_ristorante: this.id_ristorante,
                id_menu: this.order.id_menu,
                id_locale: this.locale.id,
                api_key: this.user.api_key,
            }).then((response) => {
                this.advices = response.consigli;
                this.general_notes = response.note_generali ? response.note_generali.replace('\n', '<br>') : '';
                this.categories = response.categorie_prodotti_lista;
            }).catch(({messages}) => {
                alert(messages.join('\n'));
            }).finally(() => {
                this.showLoading(false);
            });
        },
        ...mapActions('global', [
            'showLoading'
        ])
    }
}
</script>
